import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {WebmateErrorHandler} from '../errorhandling/webmate.errorhandler';
import {AuthService} from '@webmate-web-core/shared/services/auth.service';
import {Popover} from 'primeng/popover';

@Component({
    selector: 'wm-userdropdown',
    styleUrls: ['./user-dropdown.component.less'],
    template: `
        <div>
            <div class="wm-userdropdown-label" data-testing-id="userdropdown-label" (click)="op.toggle($event)">
                <ng-content></ng-content>
            </div>
            <p-popover appendTo="body" [styleClass]="'navbar-dropdown'" #op>
                <a class="wm-userdropdown-item" data-testing-id="navbar-user-menu-profile" (click)="navigateToProfile(op)" [ngClass]="{'chosen': router.url.includes('/user-profile')}"> Profile</a>
                <a class="wm-userdropdown-item" data-testing-id="navbar-user-menu-about" (click)="navigateToAbout(op)"> About </a>
                <a class="wm-userdropdown-item" data-testing-id="navbar-user-menu-signout" (click)="navigateToSignOut(op)"> Sign out</a>
            </p-popover>
        </div>
    `
})
export class UserDropdownComponent {

    constructor(protected router: Router, private errorHandler: WebmateErrorHandler, private authService: AuthService) {
    }

    navigateToProfile(op: Popover) {
        op.hide();
        this.router.navigate(['/user-profile']);
    }

    navigateToAbout(op: Popover) {
        op.hide();
        window.open('https://docs.webmate.io/releases/latest');
    }

    navigateToSignOut(op: Popover) {
        op.hide();
        this.errorHandler.suppressErrors();
        this.authService.logout();
    }


}
